import { connectFela } from '../../dependencies';
import PasswordField from './PasswordField';
import * as styles from './PasswordField.styles';

export default connectFela(styles)(PasswordField);
